// extracted by mini-css-extract-plugin
export default {"wrapper":"FileInput_wrapper__831zA","input-wrapper":"FileInput_input-wrapper__+LATz","icon":"FileInput_icon__ht+F7","realInput":"FileInput_realInput__8K8rT"};